import Calendar from '../Calendar'
import './index.scss'

const Events = () => {

    return (
        <Calendar />
    )
}

export default Events